<div class="fc-product-detail-header">
    <span class="fc-product-detail-header-brand fcp-text-body-l" data-e2e-hook="pdp-brand-name" fc-skeleton>
        {{ article?.brandName }}
    </span>

    <div class="fc-product-detail-header-content-wrapper" fc-skeleton>
        <span class="fc-product-detail-header-label fcp-text-body-m">
            {{ 'ORDER.PRODUCT_DETAILS.ARTICLE_NAME' | translate }}
        </span>
        <span class="fc-product-detail-header-value fcp-text-body-m" data-e2e-hook="pdp-article-name">
            {{ article?.name || '-' }}
        </span>
    </div>

    <div class="fc-product-detail-header-content-wrapper" fc-skeleton>
        <span class="fc-product-detail-header-label fcp-text-body-m">
            {{ 'ORDER.PRODUCT_DETAILS.ARTICLE_NUMBER' | translate }}
        </span>
        <span class="fc-product-detail-header-value fcp-text-body-m" data-e2e-hook="pdp-article-number">
            {{ article?.articleNumber || '-' }}
        </span>
    </div>
</div>
